import type { CSSProperties } from "react";
import "./RichText.css";

export interface RichTextProps {
  readonly html?: string | null;
  readonly className?: string;
  readonly style?: CSSProperties;
}

// Renders admin-authored rich content (Quill HTML from the admin app's WYSIWYG).
// Quill sanitizes to a safe tag set on input, so the stored content is rendered directly
// (same trust model the admin app uses for template/preview bodies).
function RichText({ html, className, style }: RichTextProps) {
  if (!html || !html.trim()) return null;
  return (
    <div
      className={`rich-text ${className ?? ""}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default RichText;
